// extracted by mini-css-extract-plugin
export default {"tripCard":"Trip_tripCard__3kH61"};